import React from 'react';

import { StreamerStatus, InputEmitter } from '@pureweb/platform-sdk';

import PurewebClientOptions from './helpers';
import { ParticipantPosition } from '../interfaces';
import { SpatialType } from '@interfaces/webSocketConnectionInfo';
import { PlayerSession } from '@interfaces/event';
import { IiXRHrData } from '@clients/ek/interfaces';

export interface PurewebViewProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  streamerStatus: StreamerStatus;
  inputEmitter: InputEmitter;
  videoStream: MediaStream;
  enterPureweb: boolean;
  clientOptions: PurewebClientOptions | null;
  setEnterPureweb: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenChat: boolean;
}

export enum PurewebStreamerMessageAction {
  PositionChanged = 'POSITION_CHANGED',
  ParticipantPosition = 'PARTICIPANT_POSITION',
}

export interface PlayerPosition {
  CurrentGameSessionId: string;
  eventId: string;
  roomId: string;
  x: number;
  y: number;
  z: number;
  r: number;
}

export interface IPurewebStreamerMessage {
  action: PurewebStreamerMessageAction;
  timestamp: string;
  playerId?: string;
  playerPosition?: PlayerPosition;
  usersinscreen?: string[];
  regionName?: string;
  regionSpatialType?: SpatialType;
  isSeatRegion?: boolean;
}

export type CheckIsPurewebStreamerMessageAction = (
  action: PurewebStreamerMessageAction,
) => boolean;

export interface IInitMessage {
  action?: string;
  token: string;
  webSocketUrl: URL;
  apiUrl: string;
  participantId: string;
  participantFullName: string;
  participantFirstName: string;
  participantLastName: string;
  role: string;
  changePositionInterval: number;
  eventId: string | undefined;
  avatarId: string | null;
  skinId: string | null;
  roomId: string;
  screenHeight: number;
  screenWidth: number;
  downloadAvatarUrl: string;
  isMobile: boolean;
  deviceProfile: string;
  dolbyToken: string;
  isSpeaker: boolean;
  useLastParticipantPosition: boolean;
  lastParticipantPosition: ParticipantPosition;
  gamelift: {
    playerSession: PlayerSession | null;
  };
  mapName: string;
  multiPlayer: boolean;
  gender?: string;
  hrData?: IiXRHrData;
  hasUniform?: boolean;
  deactivateTeleport?: boolean;
  userProfile?: {
    color: string;
    initials: string;
  };
  eventTags?: string[];
  sessionKey?: string;
  virtualAssistantName?: string;
}

export interface ISelectAvatarMessage {
  action: string;
  avatarId: string;
  type: string | undefined;
  skinId: string;
  downloadAvatarUrl: string;
}
